/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface AdminInfoState {
  adminDetails: string;
}

const initialState: AdminInfoState = {
  adminDetails: '',
};

export const adminInfoSlice = createSlice({
  name: 'adminInfo',
  initialState,
  reducers: {
    setAdminDetails: (state, { payload }) => {
      const name = payload?.name ?? '';
      const email = payload?.email ?? '';
      if (name.length > 0 && email.length > 0) {
        state.adminDetails = `(${name}, ${email})`;
      }
      if (email && name.length === 0) {
        state.adminDetails = `(${email})`;
      }
    },
  },
  extraReducers: () => {},
});

export const { setAdminDetails } = adminInfoSlice.actions;
export const adminInfoSelector = (state: RootState) => state.adminInfo;
